import { useSelector } from 'react-redux';
import { MobileAccountBoxBlockPlSkeleton2Styled } from './styled/MobileAccountBoxBlockPl2Styled';
import classNames from 'classnames';
import amountFormat from '../../../../utils/amountFormat';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import { getAccountPlParamsSelector } from '../../../../modules/LiteTrade/liteTradeSelectors';

interface IMobileAccountBoxBlockPl2Props {
    className?: string,
}

function MobileAccountBoxStatPl(props: IMobileAccountBoxBlockPl2Props) {
    const { className } = props;
    const { getLangPath } = useLangContext();
    const {
        pl,
        show,
    } = useSelector(getAccountPlParamsSelector);

    if (!show) {
        return <MobileAccountBoxBlockPlSkeleton2Styled/>;
    }

    return <span className={classNames({ 'positive': pl > 0 }, className)}>
        <span>{amountFormat(pl || 0, 2, '$', false, {
            withSign: true,
        })}</span>
        <span className={'text-secondary ms-2'}>
            {getLangPath('lite_version.home.presets_stat_pl.day')}
        </span>
    </span>;
}

export default MobileAccountBoxStatPl;
